var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"column is-two-fifths"},[_c('notificationGroupsEdit',{attrs:{"id":this.id,"canEditNotificationGroup":this.canEditNotificationGroup},on:{"group-update-complete":_vm.goBack,"cancel-update":_vm.goBack}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }